<template>
  <filter-option-tile-expanded v-model="modelValue" v-bind="{ filter: filterValue, layout, loading }" />
</template>

<script lang="ts" setup>
import type { SizeFilter } from '#types/filters'

const { layout = 'flex', filter } = defineProps<{
  filter: SizeFilter
  layout?: 'flex' | 'grid'
  loading?: boolean
}>()

const modelValue = defineModel<string[]>()

const filterValue = {
  ...filter,
  options: filter.options.map(({ label, ...option }) => ({
    ...option,
    label: `${label}%`
  }))
}
</script>
